<template>
  <div class="user-reviews">
    <div class="user-reviews__container">
      <div class="user-reviews__visible-reviews">
        <div
          class="user-reviews__review"
          :key="review.username"
          v-for="review in visibleReviews">
          <user-review
            :review="review" />
        </div>
      </div>

      <a
        class="user-reviews__show-all-reviews"
        v-if="!allReviewsVisible"
        href="#"
        @click.prevent="allReviewsVisible = true">
        {{ $t("showMoreReviews") }}
      </a>

      <transition name="fade-reviews">
        <div
          v-if="allReviewsVisible"
          class="user-reviews__hidden-reviews">
          <div
            class="user-reviews__review"
            :key="review.username"
            v-for="review in hiddenReviews">
            <user-review
              :review="review" />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import UserReview from "@/pages/book/components/user-review";
import messages from "@/pages/book/components/i18n/user-reviews";

const SHOWN_REVIEWS = 4;

export default {
  name: "UserReviews",
  components: {
    UserReview
  },
  data() {
    return {
      allReviewsVisible: false
    };
  },
  computed: {
    visibleReviews() {
      const allReviews = this.$t("reviews");

      return allReviews.slice(0, SHOWN_REVIEWS);
    },
    hiddenReviews() {
      const allReviews = this.$t("reviews");

      return allReviews.slice(SHOWN_REVIEWS, -1);
    }
  },
  i18n: { messages }
};
</script>

<style lang="scss">
.user-reviews {

  &__review {

    &:not(:last-child) {
      margin-bottom: $spacing-32;
    }
  }

  &__visible-reviews {
    margin-bottom: $spacing-32;
  }

  &__show-all-reviews {
    display: block;

    text-align: center;
    text-decoration: underline;
  }
}

.fade-reviews-enter-active,
.fade-reviews-leave-active {
  transition: opacity 0.15s;
  transition-timing-function: ease-in;
}

.fade-reviews-enter,
.fade-reviews-leave-to {
  opacity: 0;
}
</style>
